<template>
  <v-app id="login-home">
    <v-content>
      <transition mode="out-in">
        <router-view />
      </transition>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    metaInfo () {
      if (process.env.VUE_APP_ORG === 'todd') {
        return {
          title: 'SELAT HR - log in',
        }
      } else {
        return {
          title: 'FRANCO HR - log in',
        }
      }
    },
  }
</script>

<style lang="scss">
  @import '@/styles/index.scss';
</style>
